import { createSlice } from '@reduxjs/toolkit';
import { loadUserFromLocalStorage, sanitizeStoredUser } from '../../utils/auth';

const initialState = {
  user: loadUserFromLocalStorage(), // Load user from localStorage
  isAuthenticated: loadUserFromLocalStorage() ? true : false, // Set initial authenticated state
};
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Login action
    login(state, action) {
      state.isAuthenticated = true;
      const payloadUser = action.payload.user || action.payload;
      const user = sanitizeStoredUser(payloadUser);
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user)); // Store user in localStorage
      if (action.payload.token || payloadUser.token) {
        localStorage.setItem('token', action.payload.token || payloadUser.token); // Store token in localStorage
      }
      localStorage.removeItem('refreshToken');
    },
    // Logout action
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      localStorage.removeItem('user'); // Clear user from localStorage
      localStorage.removeItem('token'); // Clear token from localStorage
      localStorage.removeItem('refreshToken');
    },
    // Set user action (to load user)
    setUser(state, action) {
      const user = sanitizeStoredUser(action.payload);
      state.user = user;
      state.isAuthenticated = true;
      localStorage.setItem('user', JSON.stringify(user)); // Store user in localStorage
    },
    // Load user action (to be used in App.js)
    loadUser(state) {
      const user = loadUserFromLocalStorage();
      if (user) {
        state.user = user;
        state.isAuthenticated = true;
      } else {
        state.user = null;
        state.isAuthenticated = false;
      }
    },
  },
});

export const { login, logout, setUser, loadUser } = authSlice.actions;
export default authSlice.reducer;
